import { Typography } from '@material-ui/core'

import { getTranslate } from '../../../localization'
import useStyles from './styles/reservesModalTableHead.styles'

const AccomodationAccountViewTransactionModalTableHead = () => {
  const classes = useStyles()
  return (
    <div className={classes.tableHead}>
      <Typography variant="body1">{getTranslate('#')}</Typography>
      <Typography variant="body1">{getTranslate('Status')}</Typography>
      <Typography variant="body1">{getTranslate('Reason')}</Typography>
      <Typography variant="body1">{getTranslate('Reservation Num')}</Typography>
      <Typography variant="body1">{getTranslate('Can Retry')}</Typography>
    </div>
  )
}
export default AccomodationAccountViewTransactionModalTableHead
